import { __extends } from "tslib";
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React from 'react';
import { DropDownListWithSearch } from "../DropDownListWithSearch";
import { ISelectedNode } from "../../models/node";
import { ISelectNodePayload, ISortOrderNodePayload } from "../../state/actions";
var DragHandle = (function (_super) {
    __extends(DragHandle, _super);
    function DragHandle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSortClick = function () {
            var _a = _this.props, optionType = _a.optionType, selectedOption = _a.selectedOption, onSortOrder = _a.onSortOrder;
            onSortOrder({ selectedOption: selectedOption, optionType: optionType });
        };
        return _this;
    }
    DragHandle.prototype.render = function () {
        var _a = this.props, options = _a.options, optionType = _a.optionType, placeholder = _a.placeholder, selectedOption = _a.selectedOption, selectDisabled = _a.selectDisabled, noResultsText = _a.noResultsText, onOptionSelected = _a.onOptionSelected, onOptionUnselected = _a.onOptionUnselected;
        return (React.createElement("div", { className: classnames({
                'rb-report-option': true,
                'rb-report-option-draggable': selectDisabled,
            }) },
            React.createElement(DropDownListWithSearch, { list: options, hideOptions: true, placeholder: placeholder, selected: selectedOption && selectedOption.value, disabled: selectDisabled, noResultsText: noResultsText, optionSelectedCallback: function (selectedOptionValue) { return onOptionSelected({ value: selectedOptionValue, optionType: optionType }); } }),
            this.renderSortButton(),
            React.createElement("div", { className: 'rb-btn-close', onClick: function () { return onOptionUnselected({ value: selectedOption.value, optionType: optionType }); } },
                React.createElement("i", null,
                    React.createElement(FontAwesomeIcon, { icon: faTimesCircle })))));
    };
    DragHandle.prototype.renderSortButton = function () {
        var _a = this.props, selectedOption = _a.selectedOption, sortButton = _a.sortButton;
        if (!selectedOption || !selectedOption.value) {
            return null;
        }
        return (React.createElement("div", { className: 'rb-btn-sort', onClick: this.onSortClick }, sortButton));
    };
    return DragHandle;
}(React.PureComponent));
export { DragHandle };
